import IStorage from "./IStorage";

/**
 * @class SessionStorage
 * @description Maneja la información de la sesion.
 */
export default class SessionStorage implements IStorage {
    /**
     * Obtiene los datos del storage a partir de una clave
     *
     * @param {string} key Clave a retornar
     * @returns {Object | null} retorna el objeto guardado en la memoria.
     */
    public getStorage(key: string): object | null {
        const data: string | null = sessionStorage.getItem(key);
        return data && JSON.parse(data) || null;
    }

    /**
     * Obtiene los datos del storage a partir de una clave.
     * is JSON strict, lowercase keys
     *
     * @param {string} key Clave a retornar
     * @returns {Object | null} retorna el objeto guardado en la memoria.
     */
    public getJSON(key:string): object | null {
        const value = sessionStorage.getItem(key)?.replace(/"([^"]+)":/g, function ($0, $1) { return ('"' + $1.toLowerCase() + '":') });
        if (!value) return null;
        return JSON.parse(value);
    }

    /**
     * Sete valores en el storage a partir de una clave y un objeto.
     *
     * @param {string} key Clave a guardar
     * @param object {Object | null} Objeto a guardar con esa clave.
     */
    public setStorage(key:string, object: object): void {
        sessionStorage.setItem(key, JSON.stringify(object));
    }

    /**
     * Remove all local storage if key is null.
     *
     * @param {string | null} key Clave a borrar
     */
    public deleteStorage(key?: string | null): void {
        key && sessionStorage.removeItem(key) || sessionStorage.clear();
    }

    /**
     * Exist key
     *
     * @param {string} key Clave a validar
     * @returns {boolean}  true: Exist | false: Not exist
     */
    public exists (key: string): boolean {
        return !!sessionStorage.getItem(key)
    }
}
